module.exports = __webpack_public_path__ + "static/img/doctor1-bg.084540d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider/doctor1-bg.jpg
// module id = 74CS
// module chunks = 7